// Local-only deletion flow. Each record is one deleted item (a client, interview, admin sub-user
// or client sub-user) together with its deletion request details. Records are persisted with the
// rest of the store by redux-persist, so they survive page changes and reloads, and are wiped
// with localStorage on logout. Replace with the delete APIs once they are ready.

import {
  LOCAL_DELETE_RECORD,
  LOCAL_PERMANENTLY_DELETE_RECORD,
  LOCAL_RESTORE_RECORD,
} from "../action/types";

const INIT_STATE = {
  records: [],
};

const isSameRecord = (record, payload) =>
  record.type === payload.type && record.entityId === payload.entityId;

export default (state = INIT_STATE, action) => {
  switch (action.type) {
    case LOCAL_DELETE_RECORD:
      return {
        ...state,
        records: [
          { ...action.payload, status: "deleted" },
          ...state.records.filter(
            (record) => !isSameRecord(record, action.payload),
          ),
        ],
      };
    case LOCAL_PERMANENTLY_DELETE_RECORD: {
      // A record that was already deleted locally keeps its request details.
      const existing = state.records.find((record) =>
        isSameRecord(record, action.payload),
      );
      return {
        ...state,
        records: [
          {
            ...(existing || action.payload),
            status: "permanentlyDeleted",
            permanentlyDeletedAt: action.payload.deletedAt,
          },
          ...state.records.filter(
            (record) => !isSameRecord(record, action.payload),
          ),
        ],
      };
    }
    case LOCAL_RESTORE_RECORD:
      return {
        ...state,
        records: state.records.filter(
          (record) => !isSameRecord(record, action.payload),
        ),
      };
    default:
      return state;
  }
};
